export default __webpack_public_path__ + "static/neue-haas-grotesk-display-56-roman-italic-bcdd27c94ef063c6df5c45f2254189e2.woff";